jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
	validate: {
		checkboxIsChecked: function checkboxIsChecked(elem) {
			if (elem !== null) {
				if (elem instanceof jQuery) {
					return elem.prop('checked') === true ? true : false;
				} else {
					if (elem.length > 1) {
						// Kann auch eine nodeList übegeben werden
						elem.forEach((checkbox) => {
							return checkbox.checked ? true : false;
						});
					} else {
						return elem.checked ? true : false;
					}
				}
			}
		},

		/**
		 * @param element {Element}
		 * @param testValue {string}
		 * @returns {boolean}
		 */
		selectBoxHasValue: function (element, testValue) {
			if (element instanceof jQuery) {
				return $j.trim(element.val()) === testValue;
			} else if (element instanceof HTMLElement) {
				return element.value.trim() === testValue;
			}
		},

		/**
		 * @param element {Element}
		 * @returns {boolean}
		 */
		toggleIsChecked: function (element) {
			if (element instanceof jQuery) {
				return element.filter(':checked').length > 0;
			} else if (element instanceof HTMLElement) {
				return element.checked === true;
			}
		},

		/**
		 * @param elem {HTMLTextAreaElement | NodeList}
		 * @returns {boolean}
		 */
		textfieldIsEmpty: function textfieldIsEmpty(elem) {
			let inputValue = '';
			if (elem !== null) {
				if (elem instanceof jQuery) {
					return $j.trim(elem.val()) === '';
				} else {
					if (elem.length > 1) {
						// Kann auch eine nodeList übegeben werden
						elem.forEach((inputField) => {
							inputValue = inputField.value.trim();
							return inputValue === '';
						});
					} else {
						inputValue = elem.value.trim();
						return inputValue === '';
					}
				}
			}
		},

		hasMinimumWordsFilled: function (input, minWords) {
			const re = new RegExp('([^ ]+ +){' + (minWords - 1) + ',}[^ ]+', 'g');
			const trimmedValue = $j.trim(input.value);

			return re.test(trimmedValue);
		},

		isNumber: function isNumber($elem) {
			const value = $elem.val().trim().replace(/ /g, ''); // Alle Leerzeichen raus wegen Payment CC
			return $j.isNumeric(value);
		},

		/**
		 *
		 * @param element {Element}
		 * @returns {boolean}
		 */
		isEmailAddress: function isEmailAddress(element) {
			if (element !== null) {
				const emailValidationReg =
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

				if (element instanceof jQuery) {
					return emailValidationReg.test(element.val()) === true;
				} else if (element instanceof HTMLElement) {
					return emailValidationReg.test(element.value) === true;
				}
			}
		},

		isNotTabOrShiftKey: function isNotTabOrShiftKey(keyCode) {
			return keyCode !== 9 && keyCode !== 16;
		},

		isMouseclickEnterOrSpaceKey: function (keyCode) {
			const isMouseClick = keyCode === undefined;
			const isEnterKey = keyCode === 13;
			const isSpaceKey = keyCode === 32;

			return isMouseClick || isEnterKey || isSpaceKey;
		},
	},
});
